<template>
    <div
        class="ct-offcanvas-panel map-add-feature-panel"
        :style="{ 'margin-bottom': panelBottom}"
        v-show="show">
        <button
            v-if="!isActionNewOccurrence"
            type="button"
            :disabled="isActionNewOccurrence"
            @click.prevent="onAddFeature"
            class="btn btn-rounded btn-responsive btn-lg btn-tertiary-main btn-add-feature">
            {{ txtAddTitleButton }}
        </button>
        <button
            v-else
            type="button"
            @click.prevent="onCancelAddFeature"
            class="btn btn-rounded btn-responsive btn-lg btn-outline-grape-fruit btn-add-feature">
            {{ txtCancelTitleButton }}
        </button>
    </div>
</template>

<script>
    // import GlobalMixin from '@/app/shared/mixins/global';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import {default as IdentifyInteraction, IdentifyEventType} from '../ol/interaction/Identify';
    import { genId } from '@config/utils';
    // import { detectMobile } from "@config/browser";
    import { MAP_ACTIONS } from '@config/constants';
    import { EVENTS } from '@/app/shared/utils/constants';
    import VectorLayer from 'ol/layer/Vector'
    import VectorImageLayer from 'ol/layer/VectorImage';

    let vars = {
        defaultIdControl: 'addfeature',
        interactions: {
            identify: null,
            modify: null,
        }
    };

    export default {
        hiddenLayers: [],
        mixins: [
            ButtonControlMixin
        ],
        props: {
            // label: {
            //     type: String,
            //     require: true
            // },
            idControl: {
                type: String,
                default: vars.defaultIdControl,
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.NEW_OCCURRENCE,
            },
            cancelTitleButton: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.cancel`
            },
            infoLocal: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.help`
            },
            infoNoPermission: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.not_allowed`
            },
            infoOutside: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.out_boundary`
            },
            infoAtiveFilter: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.active_filter`
            },
            infoAddressNotFount: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.address_not_found`
            },
            infoModifyPosition: {
                type: String,
                require: false,
                default: `${vars.defaultIdControl}.modify_position`
            },
            forceAutenticatedOnCreate: {
                type: Boolean,
                default: true,
            },
            eventInitialize: {
                type: String,
                default: EVENTS.INITIALIZE_NEW_FEATURE,
            },
            eventCanceled: {
                type: String,
                default: EVENTS.CANCELED_NEW_FEATURE,
            },
            eventFinished: {
                type: String,
                default: EVENTS.FINISHED_NEW_FEATURE,
            },
            eventShowModal: {
                type: String,
                default: EVENTS.SHOW_MODAL_NEW_FEATURE,
            },
        },
        data() {
            return {
                idPanel: this.idControl,
                idFilterTypePanel: 'filtertype',
                bottom: 0,
                show: true,
            }
        },
        computed: {
            panelTool(){
                return this.tool && this.tool.panel ? this.tool.panel : {};
            },
            txtAddTitleButton(){
                return this.$t(this.title);
            },
            txtCancelTitleButton(){
                return this.$t(this.panelTool.cancelTitleFeature ? this.panelTool.cancelTitleFeature : this.cancelTitleButton);
            },
            infoLocalAddFeature(){
                return this.$t(this.panelTool.infoAddFeature ? this.panelTool.infoAddFeature : this.infoLocal);
            },
            infoOutsideAddFeature(){
                return this.$t(this.panelTool.infoOutsideAddFeature ? this.panelTool.infoOutsideAddFeature : this.infoOutside);
            },
            infoAtiveFilterFeature(){
                return this.$t(this.panelTool.infoAtiveFilterFeature ? this.panelTool.infoAtiveFilterFeature : this.infoAtiveFilter);
            },
            infoNoPermissionAddFeature(){
                return this.$t(this.panelTool.infoNoPermissionAddFeature ? this.panelTool.infoNoPermissionAddFeature : this.infoNoPermission);
            },
            infoAddressNotFountFeature(){
                return this.$t(this.panelTool.infoAddressNotFountFeature ? this.panelTool.infoAddressNotFountFeature : this.infoAddressNotFount);
            },
            infoModifyPositionFeature(){
                return this.$t(this.panelTool.infoModifyPositionFeature ? this.panelTool.infoModifyPositionFeature : this.infoModifyPosition);
            },
            isActionNewOccurrence() {
                return this.$store.getters[`${this.moduleCode}/getActionMap`] == this.actionName;
            },
            enableUpdateBottom() {
                return false; //this.themeLayoutConfig.map.updateMapButtonPositionBottom && !detectMobile();
            },
            panelBottom(){
                return this.enableUpdateBottom ? this.bottom : null; //'inherit'
            },
            userFeature() {
                return this.$store.getters[`${this.moduleCode}/getUserFeatureMap`];
            },
            filterTypePanel(){
                return this.$store.getters[`${this.moduleCode}/getPanel`](this.idFilterTypePanel);
            },
            collapsedFilterTypePanel() {
                return !!this.filterTypePanel.collapsed;
            },
            heightFilterTypePanel() {
                return this.filterTypePanel.height;
            },
            configMap() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getConfigMap`] : {};
            },
            layersProperties() {
                return this.configMap.layers ? this.configMap.layers.new_feature : {};
            },
            clusterProperties() {
                return this.configMap.layers;
            },
            styleProperties() {
                return this.configMap.style;
            },
            sourceId() {
                return this.layersProperties.source || {};
            },
            layerId() {
                return this.layersProperties.layer || {};
            },
        },
        created() {
            this.$eventBus.listen(this.moduleCode, this.eventFinished, this.onFinishedNewFeature);
        },
        beforeDestroy() {
            this.$eventBus.remove(this.moduleCode, this.eventFinished, this.onFinishedNewFeature);
            this.reset();
        },
        methods: {
            initialize: function() {
                if(!this.mapInitialized) return;

                this.createIdentifyInteraction();
                this.setMapLayer();
                this.setIdentifyInteraction(true);
            },
            reset: function(){
                this.removeMapInteractions();
                this.setMapLayer(true);
                this.clearSource();
                for (let i = 0, len = this.$options.hiddenLayers.length; i < len; ++i) {
                    let layer = this.$options.hiddenLayers[i];
                    layer.setVisible(true);
                }
                this.setActionMap(true);
            },
            createIdentifyInteraction(){
                let identify = vars.interactions.identify;
                if(!identify){
                    let map = this.getMap();
                    identify = new IdentifyInteraction({});
                    identify.on(IdentifyEventType.IDENTIFYCOORD, (evt) => {
                        if(this.isActionNewOccurrence){
                            if(!map.checkIntersectBoundary(evt.coordinate)) {
                                this.showWarning(this.infoOutsideAddFeature)
                            }else {
                                let isAutenticated = this.$auth.check();
                                if(this.forceAutenticatedOnCreate && !isAutenticated){
                                    return;
                                }
                                this.addFeature(evt.coordinate);
                                // this.searchAddress();
                            }
                        }
                    });
                    identify.setActive(false);
                    if(map){
                        map.addInteraction(identify);
                    }
                    vars.interactions.identify = identify;
                }
            },
            setIdentifyInteraction(flag) {
                let identify = vars.interactions.identify;
                if(flag && !identify){
                    this.createIdentifyInteraction();
                }
                if(identify){
                    identify.setActive(flag);
                    if(flag){
                        document.addEventListener('keydown', this.escapeHandler);
                    }else{
                        document.removeEventListener('keydown', this.escapeHandler);
                    }
                }
            },
            setMapInteraction(key, flag) {
                let interaction = vars.interactions[key];
                if(interaction){
                    interaction.setActive(flag);
                }
            },
            removeMapInteraction: function(key) {
                let interaction = vars.interactions[key];
                if(interaction){
                    interaction.setActive(false);
                    let _map = interaction.getMap();
                    if(_map) {
                        _map.removeInteraction(interaction);
                    }
                }
                vars.interactions[key] = null;
            },
            removeMapInteractions: function(keys='all'){
                for (let key in vars.interactions) {
                    if(keys == 'all' || keys.includes(key)){
                        this.removeMapInteraction(key);
                    }
                }
            },
            updateBottomMargin(collapsed) {
                const refHeight = this.heightFilterTypePanel;
                // this.bottom = this.bottom == 'auto' ? this.bottom : refHeight + 'px !important';
                this.bottom = refHeight + 'px !important';
            },
            onAddFeature: function() {
                if(this.isActionNewOccurrence){
                    return false;
                }
                if(this.forceAutenticatedOnCreate){
                    let isAutenticated = this.$auth.check();
                    if(!isAutenticated){
                        this.onCancelAddFeature();
                        this.$router.push({name: 'portal.login'})
                        return;
                    }
                }

                if (this.checkUserHasPermission(this.acl.view)) {
                    this.onInitializeNewFeature();
                } else {
                    this.showError(this.infoNoPermissionAddFeature)
                }
            },
            onCancelAddFeature: function() {
                this.clearMessages();
                this.$eventBus.publish(this.moduleCode, this.eventCanceled);
                this.$eventBus.publish(this.moduleCode, this.eventFinished);
            },
            addFeature: function (coordinates) {
                const _map = this.getMap();
                if(!_map){
                    return;
                }

                // criar nova feature
                let feature = _map.createFeature({
                    id: genId(),
                    longitude: coordinates[0],
                    latitude: coordinates[1],
                    style: this.getStyle()
                });

                let _source = _map.getSource(this.sourceId);
                if(_source){
                    _source.clear();
                    _source.refresh();  //Refreshes the source. The source will be cleared, and data from the server will be reloaded.
                    _source.addFeature(feature);
                    _source.changed();
                }
                this.setMapInteraction('modify', true);
            },
            setMapLayer: function(remove=false) {
                const _map = this.getMap();
                if(!_map){
                    return;
                }
                const optionsLayer = this.layersProperties;
                let sourceId = this.sourceId;
                let layerId = this.layerId;
                let _source = _map.getSource(sourceId);
                let _layer = _map.getLayer(layerId);
                if(remove) {
                    if(_source){
                        _map.removeSource(sourceId);
                    }
                    if(_layer){
                        _map.removeLayer(_layer, layerId);
                    }
                    this.removeMapInteraction('modify');
                }else{
                    if(!_layer){
                        if(!_source){
                            _source = _map.createVectorSource({});
                            _source.on('addfeature', (evt) => {
                                this.dispatchEventShow(_map, evt);
                            });
                            _map.setSource(sourceId, _source);
                        }
                        let zIndex = Math.max(Math.max(..._map.getLayers().getArray().map(o => o.getZIndex())) + 1, optionsLayer.zindex);
                        _layer = _map.createVectorLayer({
                            source: _source,
                            zIndex: zIndex,
                            style: this.getStyle(),
                        });
                        _map.setLayer(layerId, _layer);
                        _map.addlayerToMap({layer: _layer});

                    }
                    _map.clearSource(sourceId);

                    this.createModifyInteraction(_layer, _source);
                }
            },
            clearSource: function() {
                const _map = this.getMap();
                if(_map) {
                    _map.clearSource(this.sourceId);
                }
            },
            createModifyInteraction: function(_layer, _source){
                const _map = this.getMap();
                let modify = _map.createModify({
                    hitDetection: _layer,
                    source: _source,
                    pixelTolerance: 50,
                    style: this.getStyle()
                });
                modify.setActive(false);
                _map.addInteraction(modify);

                var originalCoord = {};
                modify.on('modifystart', function (evt) {
                    let feature = evt.features.item(0);
                    if(feature){
                        originalCoord = feature.getGeometry().getCoordinates();
                    };
                });
                modify.on('modifyend', (evt) => {
                    let feature = evt.features.item(0);
                    if(feature){
                        let coord = feature.getGeometry().getCoordinates();
                        if(!_map.checkIntersectBoundary(coord)) {
                            feature.getGeometry().setCoordinates(originalCoord);
                            originalCoord = null;
                            this.showWarning(this.infoOutsideAddFeature)
                            return false
                        }
                        // this.searchAddress();
                        this.dispatchEventShow(_map, evt);
                    }
                });
                vars.interactions.modify = modify;
            },
            // searchAddress: function() {
            //     let url = this.url.reverseAddress;
            //     const _map = this.getMap();
            //     let _source = _map.getSource(this.sourceId);
            //     if(url && _source){
            //         let features = _source.getFeatures() || [];
            //         let feature = features.length > 0 ? features[0] : null;
            //         if(feature) {
            //             let coordinates = feature.getGeometry().getCoordinates();
            //             let srid = _map.getProjection().getCode().split(':').pop();
            //             this.setUserFeatureMap({
            //                 id: feature.getId(),
            //                 map_coords: {
            //                     lon: coordinates[0],
            //                     lat: coordinates[1],
            //                     srid: _map.getProjection().getCode(),
            //                 },
            //                 coords: {
            //                     lon: coordinates[0],
            //                     lat: coordinates[1],
            //                 },
            //                 srid,
            //                 url,
            //             }).then(res => {
            //                 if(!this.userFeature || !this.userFeature && this.userFeature.street){
            //                     this.showError(this.infoAddressNotFountFeature, this.pageTitle, () => {
            //                         this.showMessage(this.infoModifyPositionFeature);
            //                     });
            //                 }
            //             });
            //         }
            //     }
            // },
            getStyle: function() {
                const _map = this.getMap();
                if(!_map){
                    return null;
                }
                return _map.createStyle({
                    cursor: 'pointer',
                    image: _map.createIcon({
                        src: require(`@modules/${this.moduleCode}/images/marker-new.png`),
                        anchor: [.5, 1],
                        scale: 1,
                    })
                });
            },
            onInitializeNewFeature: function() {
                this.$eventBus.publish(this.moduleCode, this.eventInitialize);

                const _map = this.getMap();
                if(!_map){
                    return;
                }
                // this.onFinishedNewFeature();
                let layers = _map.getLayers().getArray();
                for (let i = 0, len = layers.length; i < len; ++i) {
                    let layer = layers[i];
                    if(layer == _map.getLayer(this.layerId)) continue;
                    let visible = layer.getVisible();
                    if(visible){
                        //If this is a vector layer
                        if(layer instanceof VectorLayer
                            || layer instanceof VectorImageLayer){
                            // groupLyr instanceof ol.layer.Group;
                            // groupLyr instanceof ol.layer.Vector;
                            layer.setVisible(false);
                            this.$options.hiddenLayers.push(layer);
                        }
                    }
                }

                this.setActionMap();
                this.showMessage(this.infoLocalAddFeature);
            },
            onFinishedNewFeature: function() {
                this.reset();
            },
            escapeHandler: function(evt) {
                if(evt instanceof KeyboardEvent) {
                    // if(!this.userFeature){
                        if (evt.key === 'Escape') {
                            this.onCancelAddFeature();
                        }
                    // }
                }
            },
            async setUserFeatureMap(data) {
                await this.$store.dispatch(`${this.moduleCode}/setUserFeatureMap`, data);
            },
            setActionMap: function(reset=false) {
                if(reset) {
                    this.setUserFeatureMap(null);
                }
                this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action: reset ? null : this.actionName});
            },
            dispatchEventShow: function(map, evt) {
                let feature = null;
                if(evt.feature) {
                    feature = evt.feature;
                }else if(evt.features) {
                    if(evt.features.getLength()>0) {
                        feature = evt.features.item(0);
                    }
                }
                if(feature) {
                    let coordinates = feature.getGeometry().getCoordinates();
                    let crs = map.getProjection().getCode().split(':').pop();
                    let resolution = map.getResolution();

                    this.$eventBus.publish(this.moduleCode, this.eventShowModal, {
                        feature: {
                            id: feature.getId(),
                            x: coordinates[0],
                            y: coordinates[1],
                            crs,
                            resolution,
                            feature,
                            source: evt.target,
                        }
                    });
                }
            }
        },
        watch: {
            // mapInitialized: {
            //     immediate: true,
            //     handler(value, oldVal) {
            //     },
            // },
            isActionNewOccurrence: {
                immediate: false,
                handler(value, oldVal) {
                    if(value) {
                        this.initialize();
                    }else{
                        this.reset();
                    }
                },
            },
            userFeature: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.$eventBus.publish(this.moduleCode, this.eventShowModal);
                    }
                },
            },
            heightFilterTypePanel: {
                immediate: true,
                handler(value, oldValue){
                    this.updateBottomMargin(value);
                },
            },
        },

    }
</script>

<style lang="scss" scoped>
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_mixins.scss";
@import "@styles/_theme.scss";

    .btn-add-feature {
        &[class*="btn-outline-"] {
            background-color: #ffffff !important;
        }
    }
    .map-add-feature-panel {
        position: absolute;
        top: $tools-addfeature-top-default;
        bottom: $tools-addfeature-bottom-default;
        left: $tools-addfeature-left-default;
        right: $tools-addfeature-right-default;

        z-index: 1;
        margin-inline: auto;
        width: fit-content;
        text-align: center;

        @include sm {
            width: auto;
            bottom: $tools-addfeature-bottom-sm;
            left: $tools-addfeature-left-sm;
            right: $tools-addfeature-right-sm;
            top: $tools-addfeature-top-sm;
        }
        /* @include lg {
            right: $tools-addfeature-right + 1rem;
        } */

        -webkit-transition: bottom 1s ease !important;
        -moz-transition: bottom 1s ease !important;
        -ms-transition: bottom 1s ease !important;
        -o-transition: bottom 1s ease !important;
        transition: bottom 1s ease !important;

        .btn {
            min-width: 260px !important;
            margin: 0;
            // margin-bottom: .5rem;

            @include sm {
              min-width: 235px !important;
            //   margin-bottom: 1rem;
            //   margin-right: 0;
            }
            @include md {
            //   margin-bottom: 0;
            //   margin-right: 0;
            }
        }

        &.w-panel-filters {
            margin-bottom: 1.7rem;
        }
    }
</style>